// Renders PageTitle component and icon button to collapse the right pannel (triggering ui stiore set right panel open)

import { IconButton, Tooltip } from "@mui/material";
import { PanelLeft, PanelRight } from "lucide-react";
import { useParams } from "react-router-dom";
import { useKeyboardShortcuts } from "src/hooks/useKeyboardShortcuts";
import { useStore } from "src/stores";

type PageHeaderProps = {
  pageTitleComponent: React.ReactNode;
  leftButtons?: React.ReactNode;
  rightButtons?: React.ReactNode;
  rightPanelToggleVisible?: boolean;
  rightPanelToggleRequiresDevice?: boolean;
  leftPanelToggleVisible?: boolean;
};

export const PageHeader = ({
  pageTitleComponent,
  leftButtons,
  rightButtons,
  rightPanelToggleVisible = true,
  rightPanelToggleRequiresDevice = true,
  leftPanelToggleVisible = true,
}: PageHeaderProps) => {
  const { uiStore } = useStore();
  const { deviceId } = useParams();
  const canToggleAgent =
    rightPanelToggleVisible && (!rightPanelToggleRequiresDevice || !!deviceId);

  useKeyboardShortcuts(
    {
      a: () => {
        if (!canToggleAgent) {
          return;
        }

        uiStore.setIsRightPanelOpen();
      },
    },
    [canToggleAgent, uiStore]
  );

  return (
    <header className="flex items-center justify-between py-2 px-3  border-0 border-b border-solid border-gray-200 h-12">
      <div className="flex items-center gap-x-2">
        {leftPanelToggleVisible && (
          <Tooltip title="Toggle menu">
            <IconButton
              onClick={() => uiStore.setIsLeftPanelCollapsed()}
              size="small"
              edge="start"
              className="-ml-2"
            >
              <PanelLeft className="text-gray-500 size-[16px]" />
            </IconButton>
          </Tooltip>
        )}
        {leftButtons}
        {pageTitleComponent}
      </div>
      <div className="flex items-center gap-x-2">
        {rightButtons}
        {canToggleAgent && (
          <Tooltip
            title={
              <>
                Toggle agent <kbd>A</kbd>
              </>
            }
          >
            <IconButton
              onClick={() => uiStore.setIsRightPanelOpen()}
              size="small"
              edge="end"
              className="-mr-2"
              aria-label="Toggle agent"
            >
              <PanelRight className="text-gray-500 size-[16px]" />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </header>
  );
};
